import * as React from 'react';

export const PlayIcon = props => (
    <svg width={19.71} height={26.7} {...props}>
        <path
            d="M19.43,12.83,1,.11a.65.65,0,0,0-.66,0A.64.64,0,0,0,0,.64V26.06a.64.64,0,0,0,.34.57.6.6,0,0,0,.3.07A.69.69,0,0,0,1,26.59L19.43,13.87a.62.62,0,0,0,.28-.52A.64.64,0,0,0,19.43,12.83Z" />
    </svg>
);
